import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Users, ArrowLeft, Calculator, Heart, 
  ShieldCheck, Smile, Target, Users2, Gavel, Sparkles, Check, BrainCircuit, CalendarCheck, MessageSquareMore, Scale
} from 'lucide-react';

// --- IMÁGENES DEL CARRUSEL (Sección Dolor) ---
const PAIN_CAROUSEL_IMAGES = [
  "https://zaphy.com.co/wp-content/uploads/2026/01/rrhh-2.jpg",
  "https://zaphy.com.co/wp-content/uploads/2026/01/rrhh-3.jpg",
  "https://zaphy.com.co/wp-content/uploads/2026/01/rrhh.jpg"
];

const RecursosHumanos = ({ language }) => { 
  
  const navigate = useNavigate();
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % PAIN_CAROUSEL_IMAGES.length);
    }, 4000); 
    return () => clearInterval(interval);
  }, []);

  // --- DICCIONARIO DE TRADUCCIONES EVOLUCIONADA (ALEX HORMOZI + ALTA DENSIDAD SEMÁNTICA SEO) ---
  const t = {
    es: {
      back: "Volver al Inicio",
      heroTag: "Outsourcing de Recursos Humanos para PyMEs",
      heroTitle: "Tu Departamento de RR.HH.",
      heroSubtitle: "Estratégico y sin tantas trabas",
      heroDesc: "Nos convertimos en tu dirección de talento humano externa. Gestionamos el reclutamiento, la contratación blindada, el clima laboral y los procesos disciplinarios para transformar tu equipo en un motor de alto rendimiento.",
      heroBtnQuote: "Cotizar Outsourcing",
      heroBtnWhatsApp: "Escríbenos por WhatsApp",
      imgBadgeTitle: "Clima Laboral",
      imgBadgeDesc: "Equipos Motivados",
      painTag: "El problema real",
      painTitle: "¿Alta rotación de personal y baja productividad?",
      painDesc: "Tener empleados desmotivados es un drenaje financiero silencioso. No solo pierdes capital en constantes re-entrenamientos, sino que el ambiente tóxico contamina a tus mejores talentos. Además, realizar llamados de atención sin el debido proceso abre la puerta a costosas demandas laborales perdidas.",
      painHighlight: "No necesitas asumir el salario de un Gerente de RR.HH. interno y costoso. En Zaphy asumimos la operación completa por una fracción del costo y protegemos tu patrimonio.",
      painBadgeTitle: "Resultado",
      painBadgeDesc: "Retención de Talento",
      
      // Banner de Traspaso de Carga Administrativa (Modelo Hormozi de Reversión de Riesgo)
      bannerTitle: "Liderazgo Absoluto de tu Gestión Humana",
      bannerDesc: "Al delegar tu área de Personal con Zaphy, dejas en manos de profesionales expertos la construcción de perfiles de empleo, las evaluaciones de desempeño y la resolución de conflictos laborales. Asumimos el debido proceso legal de tus descargos y nos aseguramos de que cada colaborador juegue bajo reglas claras.",
      
      gridTitle: "¿Qué incluye nuestro Ecosistema de Gestión?",
      gridSubtitle: "Cubrimos de forma integral todo el ciclo de vida del colaborador en tu organización, desde el onboarding hasta su desvinculación.",
      cards: [
        { title: "Contratación & Onboarding Blindado", desc: "Elaboración minuciosa de contratos de trabajo, control estricto de carpetas de personal y procesos de inducción efectivos para asegurar la productividad desde el día uno." },
        { title: "Medición de Clima & Cultura", desc: "Diseño y aplicación de evaluaciones del clima organizacional, diagnósticos de estrés laboral y planes de bienestar estratégico para retener a tus mejores talentos." },
        { title: "Procesos Disciplinarios de Ley", desc: "Citaciones formales, dirección técnica de audiencias de descargos y estructuración de memorandos o sanciones garantizando el debido proceso legal." },
        { title: "Evaluación de Desempeño & KPIs", desc: "Implementación de métricas e indicadores de rendimiento reales para evaluar la productividad, detectar brechas operativas y planear ascensos." },
        { title: "Reclutamiento & Selección Express", desc: "Construcción del perfil del cargo, reclutamiento en plataformas premium pagas, aplicación de pruebas psicotécnicas avanzadas y verificación total de antecedentes." },
        { title: "Políticas & Reglamento de Trabajo", desc: "Redacción, actualización y socialización de políticas organizacionales y el Reglamento Interno de Trabajo frente a las exigencias vigentes del Ministerio." },
        { title: "Resolución de Conflictos Internos", desc: "Mediación profesional ante tensiones en los equipos de trabajo, acoso laboral (Comité de Convivencia) y estructuración de canales de comunicación asertivos." },
        { title: "Atención Continua al Colaborador", desc: "Canal de soporte directo para resolver dudas de tus trabajadores sobre certificaciones laborales, periodos de vacaciones, novedades y trámites de seguridad social." }
      ],
      seoTitle: 'Preguntas Frecuentes sobre el Outsourcing de Recursos Humanos en Colombia',
      seoSubtitle: 'Resolvemos tus dudas sobre contratos de trabajo, sanciones de ley y cómo la dirección externa de Zaphy potencia tu PyME.',
      faqs: [
        { q: '¿Qué es un outsourcing de recursos humanos y cómo ayuda a una PyME?', a: 'Es un modelo donde una firma experta como Zaphy asume la dirección y operación de tu área de personal. Esto le permite a las pequeñas y medianas empresas acceder a un equipo multidisciplinario de psicólogos, contadores y abogados laboralistas sin pagar la nómina interna de un departamento de gestión humana tradicional.' },
        { q: '¿Cómo nos protege Zaphy ante demandas de ex-empleados o tutelas?', a: 'La mayoría de demandas se pierden por violar el debido proceso en los llamados de atención o despidos. Nosotros nos encargamos de blindar cada paso: redactamos las citaciones a descargos de forma legal, guiamos las actas de la diligencia y nos aseguramos de que cualquier sanción o desvinculación esté rígidamente justificada bajo el Código Sustantivo del Trabajo.' },
        { q: '¿Por qué la medición del clima laboral influye en la rentabilidad del negocio?', a: 'Una alta rotación de personal genera sobrecostos en liquidaciones, pérdidas de tiempo en inducciones y baja el ritmo de facturación. Medir el clima organizacional y mitigar el estrés laboral nos permite diseñar actividades de bienestar puntuales que aumentan el sentido de pertenencia y la productividad general.' },
        { q: '¿Cómo aseguran que los nuevos empleados se adapten rápido a la operación?', a: 'Diseñamos procesos estructurados de Onboarding e inducción. Al unificar los manuales de funciones y coordinar capacitaciones iniciales, los nuevos colaboradores comprenden sus KPIs y responsabilidades técnicas desde la primera semana.' },
        { q: '¿El servicio cubre la actualización frente a las nuevas reformas laborales?', a: '¡Totalmente! Como tu aliado estratégico gerencial, reestructuramos e implementamos de forma inmediata cualquier cambio normativo que impacte tus jornadas o contratos, asegurando que tu Reglamento Interno de Trabajo cumpla siempre con la ley.' }
      ],
      ctaTitle: "¿Listo para potenciar la productividad de tu equipo?",
      ctaDesc: "Deja que nosotros cuidemos de las personas y de los procesos legales, mientras tú te enfocas al 100% en hacer crecer la facturación de tu PyME.",
      ctaBtnQuote: "Cotizar Outsourcing",
      ctaBtnSchedule: "Agendar Asesoría",
      ctaBtnWhatsApp: "Hablemos por WhatsApp"
    },
    en: {
      back: "Back to Home",
      heroTag: "Strategic Human Talent Outsourcing for PyMEs",
      heroTitle: "Your HR Department",
      heroSubtitle: "Strategic and without the hassle",
      heroDesc: "We become your external human talent management department. We handle recruitment, shielded hiring, workplace environment, and disciplinary processes to turn your team into a high-performance engine.",
      heroBtnQuote: "Quote Outsourcing",
      heroBtnWhatsApp: "Chat on WhatsApp",
      imgBadgeTitle: "Work Climate",
      imgBadgeDesc: "Motivated Teams",
      painTag: "The Real Problem",
      painTitle: "High staff turnover and low productivity?",
      painDesc: "Having demotivated employees is a silent financial drain. Not only do you lose capital on constant retraining, but a toxic environment contaminates your best talent. Additionally, issuing warnings without due process opens the door to costly lost labor lawsuits.",
      painHighlight: "You don't need to take on the salary of an expensive internal HR Manager. At Zaphy, we assume the complete operation for a fraction of the cost and protect your business assets.",
      painBadgeTitle: "Result",
      painBadgeDesc: "Talent Retention",
      
      bannerTitle: "Absolute Leadership of Your Human Management",
      bannerDesc: "By delegating your Personnel area to Zaphy, you leave the creation of employment profiles, performance evaluations, and labor conflict resolution in the hands of expert professionals. We assume the legal due process of your hearings and ensure every collaborator plays under clear rules.",
      
      gridTitle: "What does our Management Ecosystem include?",
      gridSubtitle: "We comprehensively cover the entire lifecycle of the collaborator in your organization, from onboarding to termination.",
      cards: [
        { title: "Shielded Hiring & Onboarding", desc: "Meticulous drafting of employment contracts, strict control of personnel files, and effective induction processes to ensure productivity from day one." },
        { title: "Climate & Culture Measurement", desc: "Design and application of organizational climate evaluations, workplace stress diagnostics, and strategic wellness plans to retain your top talent." },
        { title: "Legal Disciplinary Processes", desc: "Formation, periodic training, and mandatory minutes for COPASST, Labor Coexistence Committee, and Emergency Brigades." },
        { title: "Performance Evaluation & KPIs", desc: "Implementation of real performance metrics and indicators to evaluate productivity, detect operational gaps, and plan promotions." },
        { title: "Express Recruitment & Selection", desc: "Job profile construction, recruitment on paid premium platforms, advanced psychometric testing, and full background checks." },
        { title: "Personnel Policies & Regulations", desc: "Drafting, updating, and socializing organizational policies and Internal Labor Regulations against current Ministry requirements." },
        { title: "Internal Conflict Resolution", desc: "Professional mediation for team tensions, workplace harassment (Coexistence Committee), and structuring assertive communication channels." },
        { title: "Continuous Employee Support", desc: "Direct support channel to resolve your workers doubts about labor certificates, vacation periods, and social security procedures." }
      ],
      seoTitle: 'Frequently Asked Questions about HR Outsourcing in Colombia',
      seoSubtitle: 'We solve your doubts about labor contracts, legal sanctions, and how Zappings expert service.',
      faqs: [
        { q: 'What is HR outsourcing and how does it help a PyME?', a: 'It is a model where an expert firm like Zaphy assumes the direction and operation of your personnel area. This allows small and medium-sized businesses to access a multidisciplinary team of psychologists, accountants, and labor lawyers.' },
        { q: 'How does Zaphy protect us against former employee lawsuits or claims?', a: 'Most lawsuits are lost due to violating due process in warnings or dismissals. We take care of shielding every step: we draft disciplinary hearing citations legally, guide the minutes of the proceeding, and ensure any sanction is rigidly justified.' },
        { q: 'Why does measuring the organizational climate affect business profitability?', a: 'High staff turnover generates extra costs in settlements, lost time in inductions, and lowers the invoicing rate. Measuring the work climate and mitigating workplace stress allows us to design targeted wellness activities.' },
        { q: 'How do you ensure new employees adapt quickly to the operation?', a: 'We design structured onboarding and induction processes. By unifying job descriptions and coordinating initial training, we ensure new collaborators understand their KPIs and technical responsibilities from the first week.' },
        { q: 'Does the service include support and training for COPASST and Brigades?', a: 'Absolutely! As your strategic management partner, we restructure and immediately implement any regulatory change that impacts your business shifts or employee agreements.' }
      ],
      ctaTitle: "Ready to empower your team's productivity?",
      ctaDesc: "Let us take care of the people and the legal processes, while you focus 100% on growing your PyME's billing.",
      ctaBtnQuote: "Quote Outsourcing",
      ctaBtnSchedule: "Schedule Advisory",
      ctaBtnWhatsApp: "Chat via WhatsApp"
    }
  };

  const text = t[language] || t.es;

  const handleWhatsAppRedirect = () => {
    const targetUrl = `https://api.whatsapp.com/send?phone=573114044203&text=${encodeURIComponent("¡Hola, Zaphy! 🚀 Estuve revisando la suite de Gestión de Recursos Humanos en su web y quiero solicitar una asesoría comercial rápida para tener outsourcing de Recursos humanos para mi PyME.")}`;
    window.open(targetUrl, '_blank');
  };

  return (
    <div className="animate-[fadeIn_0.5s_ease-out] pt-32 pb-20 min-h-screen bg-gray-50 font-[Poppins]">
      
      {/* --- 1. HERO SECTION --- */}
      <div className="relative bg-[#0F172A] text-white py-24 overflow-hidden mb-16">
         <div className="absolute inset-0 opacity-20 bg-cover bg-center" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1200&q=80)` }}></div>
         <div className="absolute inset-0 bg-gradient-to-r from-[#0F172A] via-[#0F172A]/90 to-cyan-900/80"></div>
         
         <div className="max-w-7xl mx-auto px-4 relative z-10">
            <button onClick={() => navigate('/')} className="flex items-center gap-2 text-white/70 hover:text-white mb-6 transition-colors font-medium">
               <ArrowLeft size={20} /> {text.back}
            </button>
            
            <div className="flex flex-col md:flex-row gap-12 items-center">
                <div className="flex-1">
                    <div className="flex items-center gap-4 mb-4">
                        <div className="p-3 rounded-xl bg-cyan-500/20 text-cyan-400 border border-cyan-500/30">
                            <Users size={40} />
                        </div>
                        <span className="text-cyan-400 font-bold tracking-widest uppercase text-xs md:text-sm">{text.heroTag}</span>
                    </div>
                    
                    <h1 className="text-3xl md:text-5xl font-extrabold mb-6 leading-tight">
                    {text.heroTitle} <br/>
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">{text.heroSubtitle}</span>
                    </h1>
                    
                    <p className="text-lg text-gray-300 max-w-2xl leading-relaxed mb-8">
                    {text.heroDesc}
                    </p>

                    <div className="flex flex-wrap gap-4">
                        <button 
                          onClick={() => navigate('/cotizador')} 
                          className="bg-cyan-500 text-white font-bold py-4 px-8 rounded-2xl shadow-lg shadow-cyan-900/40 transition-all flex items-center gap-2 transform hover:-translate-y-1 hover:bg-cyan-600 text-sm uppercase tracking-wide"
                        >
                            <Calculator size={20}/> {text.heroBtnQuote}
                        </button>

                        <button 
                          onClick={handleWhatsAppRedirect} 
                          className="bg-transparent border-2 border-cyan-500 text-cyan-400 font-bold py-4 px-8 rounded-2xl transition-all flex items-center gap-2 transform hover:-translate-y-1 hover:bg-cyan-500 hover:text-slate-900 shadow-lg shadow-cyan-500/5 text-sm uppercase tracking-wide"
                        >
                            <MessageSquareMore size={20}/> {text.heroBtnWhatsApp}
                        </button>
                    </div>
                </div>

                {/* IMAGEN HERO */}
                <div className="w-full max-w-md mt-10 md:mt-0">
                    <div className="relative group">
                        <div className="absolute -inset-1 bg-gradient-to-r from-cyan-400 to-blue-600 rounded-2xl blur opacity-30 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
                        <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/10 bg-[#0F172A]">
                             <img 
                                src="https://zaphy.com.co/wp-content/uploads/2026/01/recursoshumanoszaphy.png" 
                                alt="Outsourcing de Recursos Humanos y Clima Organizacional | Zaphy" 
                                className="w-full h-auto object-cover transform transition-transform duration-500 group-hover:scale-105"
                                onError={(e) => { e.target.style.display = 'none'; }}
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/80 via-transparent to-transparent opacity-60"></div>
                            <div className="absolute bottom-4 left-4 bg-white/10 backdrop-blur-md border border-white/20 p-3 rounded-xl flex items-center gap-3">
                                <div className="bg-cyan-500 p-1.5 rounded-full text-white"><Smile size={16} /></div>
                                <div>
                                    <p className="text-xs text-cyan-200 uppercase font-bold">{text.imgBadgeTitle}</p>
                                    <p className="text-sm font-bold text-white">{text.imgBadgeDesc}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         </div>
      </div>

      {/* --- 2. EL PROBLEMA --- */}
      <div className="max-w-7xl mx-auto px-4 mb-16">
          <div className="bg-white rounded-[40px] p-8 md:p-12 shadow-xl border border-gray-100 flex flex-col md:flex-row items-center gap-12 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-cyan-50 rounded-bl-[100px] z-0"></div>
              
              <div className="md:w-1/2 relative z-10">
                  <div className="inline-flex items-center gap-2 bg-orange-50 text-orange-600 px-4 py-2 rounded-full font-bold text-sm mb-4 border border-orange-100">
                      <Target size={16} /> {text.painTag}
                  </div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-4">{text.painTitle}</h2>
                  <p className="text-gray-600 text-lg leading-relaxed mb-6">{text.painDesc}</p>
                  <p className="font-bold text-gray-800 border-l-4 border-cyan-500 pl-4">{text.painHighlight}</p>
              </div>

              {/* Columna Derecha: Carrusel de Imágenes */}
              <div className="w-full md:w-1/2 relative z-10 mt-12 md:mt-0">
                  <div className="absolute -inset-4 bg-cyan-100 rounded-[40px] transform -rotate-2 z-0"></div>
                  
                  <div className="relative z-10 rounded-[30px] shadow-lg w-full h-64 md:h-80 overflow-hidden bg-gray-200">
                      {PAIN_CAROUSEL_IMAGES.map((img, idx) => (
                          <img 
                            key={idx}
                            src={img} 
                            alt={`Gestión de Equipos y Rotación de Personal ${idx + 1}`} 
                            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${idx === currentImage ? 'opacity-100' : 'opacity-0'}`}
                            onError={(e) => { e.target.src = "https://via.placeholder.com/800x600/cccccc/969696?text=Zaphy+RRHH"; }}
                          />
                      ))}
                      
                      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 z-20">
                          {PAIN_CAROUSEL_IMAGES.map((_, idx) => (
                              <div 
                                key={idx} 
                                className={`w-2 h-2 rounded-full transition-all duration-300 ${idx === currentImage ? 'bg-cyan-400 w-4' : 'bg-white/50'}`}
                              />
                          ))}
                      </div>
                  </div>

                  <div className="absolute -bottom-6 -left-6 z-20 bg-white p-4 rounded-2xl shadow-xl border border-gray-100 flex items-center gap-3">
                      <div className="bg-green-100 p-2 rounded-full text-green-600"><Check size={24}/></div>
                      <div><p className="text-xs text-gray-500 font-bold uppercase">{text.painBadgeTitle}</p><p className="text-sm font-bold text-gray-900">{text.painBadgeDesc}</p></div>
                  </div>
              </div>
          </div>
      </div>

      {/* --- BANNER ESTRATÉGICO --- */}
      <div className="max-w-7xl mx-auto px-4 mb-24">
         <div className="bg-gradient-to-r from-slate-900 to-slate-800 rounded-[30px] p-8 md:p-10 border border-slate-700/50 shadow-xl flex flex-col md:flex-row items-center gap-8">
            <div className="bg-cyan-500/10 p-4 rounded-2xl text-cyan-400 shrink-0 border border-cyan-500/20">
               <Scale size={40} />
            </div>
            <div>
               <h3 className="text-xl md:text-2xl font-bold text-white mb-2">{text.bannerTitle}</h3>
               <p className="text-slate-300 text-sm md:text-base leading-relaxed">{text.bannerDesc}</p>
            </div>
         </div>
      </div>

      {/* --- 3. GRID DE SERVICIOS --- */}
      <div className="max-w-7xl mx-auto px-4 mb-24">
         <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">{text.gridTitle}</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">{text.gridSubtitle}</p>
         </div>

         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {text.cards.map((card, idx) => {
               const icons = [ShieldCheck, Heart, Gavel, BrainCircuit, Sparkles, Users2, Scale, Users];
               const Icon = icons[idx] || Users;
               const borderColors = ['hover:border-cyan-400', 'hover:border-pink-400', 'hover:border-red-400', 'hover:border-indigo-400', 'hover:border-purple-400', 'hover:border-blue-400', 'hover:border-emerald-400', 'hover:border-teal-400'];
               const iconColors = ['text-cyan-600 bg-cyan-50', 'text-pink-600 bg-pink-50', 'text-red-600 bg-red-50', 'text-indigo-600 bg-indigo-50', 'text-purple-600 bg-purple-50', 'text-blue-600 bg-blue-50', 'text-emerald-600 bg-emerald-50', 'text-teal-600 bg-teal-50'];
               return (
                  <div key={idx} className={`bg-white p-6 rounded-3xl border border-gray-100 hover:shadow-xl transition-all group ${borderColors[idx]}`}>
                      <div className={`w-12 h-12 ${iconColors[idx]} rounded-2xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform`}>
                         <Icon size={24} />
                      </div>
                      <h3 className="text-lg font-bold text-gray-900 mb-2">{card.title}</h3>
                      <p className="text-gray-500 text-xs md:text-sm leading-relaxed">{card.desc}</p>
                  </div>
               );
            })}
         </div>
      </div>

      {/* --- 3.5: BLOQUE DE PREGUNTAS FRECUENTES --- */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mb-24">
         <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-2">{text.seoTitle}</h2>
            <p className="text-gray-500 text-xs md:text-sm">{text.seoSubtitle}</p>
         </div>
         <div className="space-y-4">
            {text.faqs.map((faq, idx) => (
               <div key={idx} className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:border-slate-200 transition-all">
                  <h3 className="text-sm md:text-base font-bold text-gray-950 mb-2 flex items-start gap-2">
                     <span className="text-cyan-600 shrink-0">❓</span> {faq.q}
                  </h3>
                  <p className="text-gray-600 text-xs md:text-sm leading-relaxed pl-6">{faq.a}</p>
               </div>
            ))}
         </div>
      </div>

      {/* --- 4. CTA FINAL --- */}
      <div className="max-w-4xl mx-auto px-4 text-center">
         <div className="bg-gradient-to-br from-[#0F172A] to-cyan-900 rounded-[40px] p-12 text-white shadow-2xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-cyan-500/10 rounded-full blur-3xl -mr-16 -mt-16"></div>
            
            <h2 className="text-3xl md:text-5xl font-extrabold mb-6 relative z-10">{text.ctaTitle}</h2>
            <p className="text-cyan-100 text-base md:text-lg mb-8 max-w-2xl mx-auto relative z-10">{text.ctaDesc}</p>
            
            <div className="flex flex-col sm:flex-row justify-center gap-4 relative z-10">
                <button 
                  onClick={() => navigate('/cotizador')} 
                  className="bg-white text-cyan-900 font-bold py-4 px-8 rounded-xl shadow-lg hover:bg-cyan-50 transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 text-xs md:text-sm uppercase tracking-wide"
                >
                    <Calculator size={20}/>
                    {text.ctaBtnQuote}
                </button>

                <button 
                    onClick={handleWhatsAppRedirect}
                    className="bg-emerald-600 text-white font-bold py-4 px-8 rounded-xl shadow-lg hover:bg-emerald-700 transition-all transform hover:-translate-y-1 relative z-10 flex items-center justify-center gap-2 text-xs md:text-sm uppercase tracking-wide"
                >
                    <MessageSquareMore size={20}/>
                    {text.ctaBtnWhatsApp}
                </button>

                <a 
                  href="https://calendar.app.google/UYZ2ERubo552yRg19" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-transparent border-2 border-white text-white font-bold py-4 px-8 rounded-xl hover:bg-white/10 transition-all flex items-center justify-center gap-2 text-xs md:text-sm uppercase tracking-wide"
                >
                    <CalendarCheck size={20}/>
                    {text.ctaBtnSchedule}
                </a>
            </div>
         </div>
      </div>

    </div>
  );
};

export default RecursosHumanos;